<div (click)="closeMenu()" class="d-md-none" id="opacity"></div>
<div class="container-fluid header-padding">
  <app-head></app-head>
</div>
<div class="container-fluid nav-wrapper sticky-top">
  <app-menu></app-menu>
</div>
<div class="container-fluid breadcrumb-padding">
  <app-ariane></app-ariane>
</div>
<div class="container-fluid content-background">
  <main role="main">
    <router-outlet></router-outlet>
  </main>
</div>

<div class="container-fluid content-footer">
  <app-footer></app-footer>
</div>
 <ng-http-loader [entryComponent]="SPINNER_COMPONENT" [debounceDelay]="50" [minDuration]="500"
   [filteredUrlPatterns]="listeUrlToIgnore">
</ng-http-loader>
